export const SET_CUSTOMER_ACCOUNT_DATA = 'SET_CUSTOMER_ACCOUNT_DATA';
export const CLEAR_CUSTOMER_ACCOUNT_DATA = 'CLEAR_CUSTOMER_ACCOUNT_DATA';

export const setCustomerAccountData = (accountId) => ({
	type: SET_CUSTOMER_ACCOUNT_DATA,
	payload: {
		accountId,
	},
});

export const clearCustomerAccountData = () => ({
	type: CLEAR_CUSTOMER_ACCOUNT_DATA,
});
